import axios from "axios";
import driverSessionService from "../services/storage/driverSession.service";
import driverSecurityErrorEnum from "../enums/errors/transactions/driverSecurity/driverSecurityError.enum";

const chargePointHttpClient = axios.create({
  baseURL: `${process.env.REACT_APP_GATEWAY_URL}/ChargePoint/`,
  headers: {
    "Content-Type": "application/json",
  },
});

const transactionClientHttpClient = axios.create({
  baseURL: `${process.env.REACT_APP_GATEWAY_URL}/TransactionClient/`,
  headers: {
    "Content-Type": "application/json",
  },
});

const transactionPaymentHttpClient = axios.create({
  baseURL: `${process.env.REACT_APP_GATEWAY_URL}/TransactionPaymentToken/`,
  headers: {
    "Content-Type": "application/json",
  },
});

const companyHttpClient = axios.create({
  baseURL: `${process.env.REACT_APP_GATEWAY_URL}/Company/`,
  headers: {
    "Content-Type": "application/json",
  },
});

// Spec 000306 - the driver proof travels in a header on every driver call. When the server refuses it as missing
// or expired, the tab goes back to the phone step (step 1) to get a new SMS code.
const DRIVER_SESSION_HEADER = "X-Driver-Session";
const PHONE_STEP = "1";

const addDriverSessionHeader = (config) => {
  const driverSession = driverSessionService.get();
  if (driverSession) {
    config.headers = { ...config.headers, [DRIVER_SESSION_HEADER]: driverSession };
  }
  return config;
};

const handleDriverSessionRefused = (error) => {
  if (error?.response?.status === 401 && error.response.data?.errorCode === driverSecurityErrorEnum.DriverSessionRequired) {
    driverSessionService.clear();
    driverSessionService.markExpired();

    const params = new URLSearchParams(window.location.search);
    params.set("step", PHONE_STEP);
    params.delete("clientId");
    params.delete("paymentTokenId");
    window.location.replace(`${window.location.pathname}?${params.toString()}`);
  }
  return Promise.reject(error);
};

[chargePointHttpClient, transactionClientHttpClient, transactionPaymentHttpClient].forEach((httpClient) => {
  httpClient.interceptors.request.use(addDriverSessionHeader);
  httpClient.interceptors.response.use((response) => response, handleDriverSessionRefused);
});

export { chargePointHttpClient, transactionClientHttpClient, transactionPaymentHttpClient, companyHttpClient };
